import { createContext as r } from "react";
var a = r([]);
export { a as default };